export default "__VITE_ASSET__BH5bXDOv__"